'use strict';

var dateFnsTz = require('date-fns-tz');
var parsers = require('../parsers.cjs');

const partsToTimestamp = ({
  timeZone,
  isoDatePart,
  isoTimePart
}) => {
  const isoDateTimePart = parsers.combineISOParts({
    isoDatePart,
    isoTimePart
  });
  const date = dateFnsTz.zonedTimeToUtc(isoDateTimePart, timeZone);
  return date.getTime();
};

module.exports = partsToTimestamp;
//# sourceMappingURL=partsToTimestamp.cjs.map
